// app/javascript/controllers/tom_select_controller.js
import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    // Find the select element within the controller's element
    console.log("connected to tom-select");
    const selectElement = this.element.querySelector("select");
    
    if (selectElement) {
      this.tomSelect = new TomSelect(selectElement, {
        // Your Tom Select options here
        // For example:
        // create: true,
        // sortField: {
        //   field: "text",
        //   direction: "asc"
        // }
      });
    }
  }

  disconnect() {
    // Clean up TomSelect instance when the controller is disconnected
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }
  }
}